export default (theme) => ({
    modalContainer: {
        '& .MuiTextField-root': {
            marginBottom: theme.spacing(1),
            width: '100%',
        },
        '& .MuiFormControl-root': {
            width: '100%',
            boxSizing: 'border-box',
            // padding: '10px 10px',
        },
        '& fieldset.MuiFormControl-root': {
            width: '100%',
            boxSizing: 'border-box',
            padding: '10px 10px',
        },
    },
    modalContainerFlat: {
        '& .MuiTextField-root': {
            marginBottom: theme.spacing(1),
            width: '100%',
        },
        '& .MuiFormControl-root': {
            width: '100%',
            boxSizing: 'border-box',
        },
    },
    inputWithIconButton: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'row',
        '& > div:first-child': {
            width: '100%'
        }
    },
    iconButton: {
        marginTop: '15px'
    },
    iconWithLabel: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        '& .MuiTypography-root': {
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(1),
        },
    },
    icon: {
        marginTop: theme.spacing(2),
        marginLeft: theme.spacing(2),
        marginBottom: theme.spacing(1),
        cursor: 'pointer',
    },
    buttonBox: {
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(1),
        [theme.breakpoints.down('xs')]: {
            flexDirection: 'column',
        },
    },
    spanOpenDialogButton: {
        color: '#3f51b5',
        cursor: 'pointer',
        textDecoration: 'underline',
        marginLeft: theme.spacing(0.5),
    },
    gridContainer: {
        width: '100% !important',
        margin: '0px !important',
        '& .MuiGrid-root.MuiGrid-item': {
            paddingTop: '0px',
            paddingBottom: '0px',
            [theme.breakpoints.down('sm')]: {
                paddingLeft: '0px',
                paddingRight: '0px',
            },
        },
        '& .MuiGrid-root.MuiGrid-item:first-child': {
            paddingLeft: '0px',
        },
        '& .MuiGrid-root.MuiGrid-item:last-child': {
            paddingRight: '0px',
        },
    },

    // order detail modal

    massageFormLable: {
        margin: '0 0 4px',
        [theme.breakpoints.down('xs')]: {
            margin: '40px 0 4px'
        },
    },

    // products

    input_iconButton: {
        marginTop: '20px',
        marginRight: '0px',
    },
    input_icon: {
        marginLeft: '15px',
        // marginTop: '10px',
        cursor: 'pointer',
    },
    input: {
        [theme.breakpoints.down('xs')]: {
            marginTop: theme.spacing(1),
        },
    },

    inputMarginTop: {
        marginTop: 16,

        [theme.breakpoints.down('xs')]: {
            marginTop: theme.spacing(1),
        },
    },
    inputMarginBottom: {
        marginBottom: 8
    },

    resetMarginTop: {
        marginTop: '0px'
    },
    resetMarginTop_sp1_5: {
        marginTop: theme.spacing(1.5),
    },
    resetInputMarginTop: {
        marginTop: '5px'
    },
    resetInputMarginTop__desktop: {
        [theme.breakpoints.up('md')]: {
            marginTop: '5px'
        },
    },
    resetMarginBottom: {
        marginBottom: '0px'
    },
    resetMarginBottom__desktop: {
        [theme.breakpoints.up('md')]: {
            marginBottom: '0px'
        },
    },
    resetPaddingTop: {
        paddingTop: '0px'
    },
    resetPaddingBottom: {
        paddingBottom: '0px'
    },
    resetPaddingLeft_downMd : {
        [theme.breakpoints.down('md')]: {
            paddingLeft: '0px !important',
        },
    },
    resetPaddingRight_downMd : {
        [theme.breakpoints.down('md')]: {
            paddingRight: '0px !important',
        },
    },
    legeng_noWrap: {
        '& legend': {
            whiteSpace: 'noWrap',
        },
    },

    formLabel: { marginBottom: theme.spacing(1) },
    formLabel_black: { color: '#212121' },
    formLabel_blue: { color: '#3f51b5' },
    formLabel_pointer: { cursor: 'pointer' },
    formLabel_marginTop: {
        marginTop: theme.spacing(3),

        [theme.breakpoints.down('xs')]: {
            marginTop: theme.spacing(2),
        },
    },
    formLabel_marginTop_sp1: { marginTop: theme.spacing(1) },
    formLabel_marginTop_sp2: { marginTop: theme.spacing(2) },
    formLabel_marginTop_downMd: {
        [theme.breakpoints.down('md')]: {
            marginTop: theme.spacing(3),
        },

        [theme.breakpoints.down('xs')]: {
            marginTop: theme.spacing(2),
        },
    },
    formLabel_marginTop_downSm: {
        marginTop: 0,
        [theme.breakpoints.down('sm')]: {
            marginTop: theme.spacing(3),
        },

        [theme.breakpoints.down('xs')]: {
            marginTop: theme.spacing(2),
        },
    },
    formLabel_marginTop_sp2_downSm: {
        [theme.breakpoints.down('sm')]: {
            marginTop: theme.spacing(2),
        },
    },
    formLabel_withIcon: {
        display: 'flex',
        alignItems: 'center',

        '& .MuiSvgIcon-root': {
            color: '#9e9e9e',
            marginLeft: 5,
        },
    },
    formLabel_cursorPointer: {
        cursor: 'pointer'
    },

    // documents_templates

    documents_title: {
        display: 'flex',
        alignItems: 'center',

        '& img': {
            width: 22,
            marginRight: 10,
        },

        '& .MuiTypography-root.MuiTypography-body2': {
            color: '#3f51b5',
            lineHeight: 'normal',
            cursor: 'pointer',
        },
    },

    // users tasks
    periods_container: {
        margin: 0,
        width: '100%',

        '& .MuiGrid-root.MuiGrid-item:nth-child(3n)': {
            paddingLeft: 0,
            paddingRight: 12,
        },

        [theme.breakpoints.down('sm')]: {
            '& .MuiGrid-root.MuiGrid-item:nth-child(2n - 1)': {
                paddingRight: 12,
            },
            '& .MuiGrid-root.MuiGrid-item:nth-child(2n)': {
                paddingLeft: 12,
            },
        },

        [theme.breakpoints.down('xs')]: {
            '& .MuiGrid-root.MuiGrid-item:nth-child(n)': {
                paddingLeft: 0,
                paddingRight: 0,
            },
        },
    },

    days_reminder_container: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(2),
    }
});
